export const formatDate = (date: string | Date, timeZone?: string) => {
    const dateObj = date instanceof Date ? date : new Date(date);

    return dateObj.toLocaleDateString([], {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        timeZone
    });
};
